import _ from 'lodash'

import {
    LOAD_REALESTATES_ESTATES_OWNERSHIP_ESTATE_DETAIL_DATA_TABLE,
    DATA_REQUEST,
    REMOVE_REALESTATES_ESTATES_OWNERSHIP_ESTATE_DETAIL_DATA_TABLE,
} from './constants'

import config from '../../../../../../../../../../../../../../../config'

export function loadDataTable(id, listId, objectId) {
    return {
        type: LOAD_REALESTATES_ESTATES_OWNERSHIP_ESTATE_DETAIL_DATA_TABLE,
        data: {
            id,
            listId,
            objectId,
        },
    }
}

export function loadDataTableRequest(module, id, blockKey, listId, objectId, qs) {
    const tableConfig = _.get(config, `api.${module}.${blockKey}.extended.estateDetail`, {})

    return {
        type: DATA_REQUEST(module, id, blockKey, listId, objectId),
        payload: {
            ...tableConfig,
            uriParams: {
                [config.modules[module].blockIdKey]: id,
                listId,
                objectId,
            },
            qs,
        },
    }
}

export function removeDataTable(id, listId, objectId) {
    return {
        type: REMOVE_REALESTATES_ESTATES_OWNERSHIP_ESTATE_DETAIL_DATA_TABLE,
        data: {
            id,
            listId,
            objectId,
        },
    }
}
